import React, { Component } from 'react'
import { Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { observer } from 'mobx-react';
import { IconeCarregar } from '../../comum/components/Icones';
import BookingDepotCard from './BookingDepotCard';

@observer
export default class TabelaBookingDepot extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    renderTabela() {
        if(this.controller.tableMessage !== "") {
            return (
                <span className="mensagem-filtrar">
                    {this.controller.tableMessage}
                </span>
                )
        } else if(this.controller.loadingBookings) {
            return <IconeCarregar tamanho="2x" />
        } else{
            return (
                <div>
                    {<ToolkitProvider
                        keyField="Id"
                        data={[...this.controller.itens]}
                        columns={[...this.controller.colunas]}
                    >
                        {props => <div>
                            {
                                window.innerWidth > 991
                                ?<BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    //noDataIndication={() => this.controller.noData}
                                    classes="tabela tabela-layout analise-critica"
                                    //onScroll={() => this.scrolling}
                                    {...props.baseProps} 
    
                                />
                                :<Row>
                                    {this.controller.itens.map((booking, index) => 
                                        <BookingDepotCard 
                                            controller={this.controller}
                                            key={index}
                                            data={booking}
                                            id={index}
                                            colunas={[...this.controller.colunas]}
                                            titulo={"EDO.Number"}
                                        />
                                    )}
                                </Row>
                            }
                        </div> }
                    </ToolkitProvider>}
                </div>
            )
        }
    }

    render() {
        return this.renderTabela()
    }
}



// WEBPACK FOOTER //
// ./src/modules/bookingdepot/components/TabelaBookingDepot.js